export default {
  GroupEmailerResubscribe: {
    mounted() {
      this.el.addEventListener('click', () => {
        // Give immediate feedback to user while we wait for a server response
        this.el.classList.add('loading');

        const { suppressionId } = this.el.dataset;

        // Dispatch event to server
        this.pushEvent('resubscribe', { suppressionId });

        // Handle response from server
        this.handleEvent('resubscribe', ({ status }) => {
          this.el.classList.remove('loading');

          if (status === 'success') {
            // Remove row from Unsubscribers table and show success toast
            this.el.closest('tr').remove();
            window.toast({
              message: 'Contact has been re-subscribed.',
              type: 'is-success',
            });
          } else {
            window.toast({
              message: 'There was an error re-subscribing this contact.',
              type: 'is-danger',
            });
          }
        });
      });
    },
  },
};
